/**
 * ClockOutReceipt (Aug 2026) — brief full-screen "shift saved" confirmation
 * so workers always KNOW the clock-out landed. Auto-dismisses; tap to close.
 * receipt: { hours: number|null, deducted?: bool } | null
 */
import React, { useEffect } from 'react';
import { CheckCircle } from 'lucide-react';

const fmtHours = (h) => {
  if (h == null || isNaN(h)) return null;
  const total = Math.round(h * 60);
  return `${Math.floor(total / 60)}h ${total % 60}m`;
};

export default function ClockOutReceipt({ receipt, onClose, autoCloseMs = 4000 }) {
  useEffect(() => {
    if (!receipt) return undefined;
    const t = setTimeout(() => onClose?.(), autoCloseMs);
    return () => clearTimeout(t);
  }, [receipt]); // eslint-disable-line

  if (!receipt) return null;
  const label = fmtHours(receipt.hours);
  return (
    <div
      className="fixed inset-0 z-[220] flex flex-col items-center justify-center p-6"
      style={{ background: 'rgba(6,14,26,0.96)', backdropFilter: 'blur(6px)' }}
      onClick={() => onClose?.()}
      data-testid="clock-out-receipt"
    >
      <div
        className="w-24 h-24 rounded-full flex items-center justify-center mb-6"
        style={{ background: 'rgba(0,200,150,0.14)', border: '1px solid rgba(0,200,150,0.4)' }}
      >
        <CheckCircle className="w-12 h-12" style={{ color: '#00C896' }} />
      </div>
      <p className="text-xl font-bold text-white mb-1">Clocked out — shift saved</p>
      {label && (
        <p className="text-4xl font-mono font-bold my-2" style={{ color: '#00C896' }} data-testid="clock-out-receipt-hours">
          {label}
        </p>
      )}
      {receipt.deducted && (
        <p className="text-sm mt-1" style={{ color: '#FFB84D' }} data-testid="clock-out-receipt-deducted">
          30-min unpaid meal break deducted (Alberta ESA)
        </p>
      )}
      <p className="text-xs mt-6" style={{ color: '#64748B' }}>Tap anywhere to dismiss</p>
    </div>
  );
}
